import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./RequisitionReportDetails.css"
import DataTable from "../../components/DataTable/DataTable";
import { useNavigate, useLocation } from 'react-router-dom';
import Excel from '../../components/Icons/excel';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState, useCallback } from "react"
import Header from "../../components/headerAdmin/Header";
import Footer from "../../components/adminFooter/Footer";
import recruiterActivityDetailReports from "../../apis/recruiterActivityDetailReports/recruiterActivityDetailReports";
import Autocomplete from '@mui/material/Autocomplete';
import { getClientByOrg } from "../../apis/organisationAdminAPI/manageClient";
import getAllDivionByOrg from "../../apis/getAllDivionByOrg/getAllDivisionByOrg";
import { UserTypeContext } from "../../AppRoute";
import {
    NotificationManager,
} from "react-notifications";
import Tooltip from '@mui/material/Tooltip';
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";



function RequisitionReportDetails({ userType }) {
  const [expanded, setExpanded] = useState(false);


    const stylesSX = {
        backdrop: {
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: '#fff',
        },
    };

    const { userRecruitmentpartnerId: orgId, userIdType: userId } = useContext(UserTypeContext)
    const [page, setPage] = useState({ skip: 0, take: 10 });
    const [saving, setSaving] = useState(false);
    const history = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)
    const [clientsDivisions, setClientsDivisions] = useState({ clients: [], divisions: [], divisionID: {} });
    const [filters, setFilters] = useState({ clientFilter: [], divisionFilter: [] })
    let { recId, startDate, endDate, field } = location.state;
    const filterFeilds = ["_id", "requisitionId", "recruiterId", "recruiterDetails"]
    const [totalCount, setTotalCount] = useState(0)

    
    const createColumns = () => {
        if (!data || !data[0]) return [];

        const columnDefinitions = [];
        const availableFields = Object.keys(data[0]).filter((key) => !filterFeilds.includes(key));

        // Define columns based on available fields in data
        if (availableFields.includes('divisionName')) {
            columnDefinitions.push({
                accessorKey: "divisionName",
                header: "Division Name",
                width: "180px",
                enableSorting: true,
                enableFiltering: false,
            });
        }

        if (availableFields.includes('placementType')) {
            columnDefinitions.push({
                accessorKey: "placementType",
                header: "Placement Type",
                width: "150px",
                enableSorting: true,
                enableFiltering: false,
            });
        }

        if (availableFields.includes('clientName')) {
            columnDefinitions.push({
                accessorKey: "clientName",
                header: "Client Name",
                width: "120px",
                enableSorting: true,
                enableFiltering: false,
            });
        }

        if (availableFields.includes('candNames')) {
            columnDefinitions.push({
                accessorKey: "candNames",
                header: "Candidate Name",
                width: "250px",
                enableSorting: false,
                enableFiltering: false,
                cell: ({ getValue }) => {
                    return renderExpandableCell(getValue());
                },
            });
        }

        // Add any other fields that might be present in the data
        availableFields.forEach((key) => {
            if (!['divisionName', 'placementType', 'clientName', 'candNames'].includes(key)) {
                let formattedTitle = key
                    .replace(/([a-z])([A-Z])/g, "$1 $2")
                    .replace(/^./, (str) => str.toUpperCase());

                columnDefinitions.push({
                    accessorKey: key,
                    header: formattedTitle,
                    width: "180px",
                    enableSorting: true,
                    enableFiltering: false,
                });
            }
        });

        return columnDefinitions;
    };

    // Render expandable cell content (similar to expandableColumns function)
    const renderExpandableCell = (rowData) => {

        if (!rowData || rowData.length === 0) return "";

        if (rowData.length === 1) {
            return (
                <div>
                    <span>Consultant Name: {rowData[0].consultantName}</span>
                    {rowData[0].startDate && <p>Start Date: {rowData[0].startDate}</p>}
                </div>
            );
        }

        const visibleItems = expanded ? rowData : rowData.slice(0, 1);

        return (
            <div className="requisiton_report_details">
                {visibleItems.map((item, index) => (
                    <div className="name_date_column content" key={index + item.consultantName}>
                        <span>Consultant Name: {item.consultantName}</span>
                        <p>{item.startDate ? "Start Date: " + item.startDate : ""}</p>
                    </div>
                ))}

                <div
                    className="requisition_report_details_toggle"
                    
                    
                >
                    {expanded ? <span onClick={() => setExpanded(!expanded)}>...hide more</span> : <span onClick={() => setExpanded(!expanded)}>...show more</span>}
                </div>
            </div>
        );
    };




    useEffect(() => {
        const getClientsDivsions = async () => {
            let payload = { recruitmentPartnerId: orgId, isActive: true }
            try {
                let response = await getClientByOrg(payload);
                let clients = response?.data?.data
                setClientsDivisions((elem) => { return { ...elem, clients } })

            } catch (error) {

                setClientsDivisions((elem) => { return { ...elem, clients: [] } })
            }

            payload = { isManageClient: false }
            try {
                let response = await getAllDivionByOrg(orgId, payload);
                let divisions = response?.data?.data
                // .map(elem => elem.divisionName)
                setClientsDivisions((elem) => { return { ...elem, divisions } })

            } catch (error) {
                setClientsDivisions((elem) => { return { ...elem, divisions: [] } })

            }
        }

        getClientsDivsions()

    }, [orgId])

    const getData = useCallback(async () => {
        setLoading(true)
        setData(null)

        let requisitionsFilterId = "", candidateFilterId = ""

        if (field === "SC2" || field === "SC1")
            requisitionsFilterId = field
        else
            candidateFilterId = field

        try {
            const resp = await recruiterActivityDetailReports({
                orgId,
                "page": page.skip / page.take + 1,
                "size": page.take,
                "formattedDatestart": startDate.slice(0, startDate.indexOf('T')),
                "formattedDateend": endDate.slice(0, endDate.indexOf('T')),
                "isExport": false,
                userId,
                role: userType,
                "additionalFilter": {
                    "divisionId": filters.divisionFilter,
                    "clientName": filters.clientFilter,
                    recId,
                    requisitionsFilterId,
                    candidateFilterId
                }
            })
            setData(resp?.data)
            setTotalCount(resp.totalCount[0]?.totalCount)

        }
        catch (error) {
            setData(null)
            console.log(error, "error")

        }

        setLoading(false)
    }, [orgId, page, startDate, endDate, userId, userType, filters, recId, field])


    useEffect(() => {
        getData()
    }, [getData])


    // export data to excel //
    const exportExcel = async() => {

        if (data === null || data?.length === 0) {
            NotificationManager.error("No data found", "Error", 10000);
            return;
        }
        setSaving(true)


        let exportData = data.map((elem) => {



            let name_date = elem["candNames"].map((innerElem) => `name : ${innerElem.consultantName} Start Date : ${innerElem.startDate === null || innerElem.startDate === "" ? "No date present" : innerElem.startDate}`).join(',  ')

            return { "Division Name": elem.divisionName, "Placement Type": elem.placementType, "Client Name": elem.clientName, "Candidate Names": name_date }
        })
        // Lazy load XLSX only when needed for export
        const { utils, writeFile } = await import("xlsx");
        const ws = utils.json_to_sheet(exportData);

        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Data");
        writeFile(wb, "Recruiter's Activity report details.xlsx");
        setSaving(false)
    }

    const gotoReports = () => {
        history("/requisition-reports")
    }

    // change page of displayed data //
    const handlePageChange = (newPage, newPageSize) => {
        if (loading) return;
        setPage({
            skip: (newPage - 1) * newPageSize,
            take: newPageSize
        });
    };

    const handlePageSizeChange = (newPageSize) => {
        if (loading) return;
        setPage({
            skip: 0,
            take: newPageSize
        });
    };

    const handleClientNameChange = (event, clientFilter) => {
        setFilters(elem => { return { ...elem, clientFilter: clientFilter.map((elem) => elem._id) } })
    }
    const handleDivisionChange = (event, divisionFilter) => {
        setFilters(elem => { return { ...elem, divisionFilter: divisionFilter.map((elem) => elem._id) } })
    }

    const handleSearch = async (event) => {

        setPage((prop) => {
            return {
                ...prop,
                skip: 0
            }
        })

    }


    return (
        <>

            {((userType === "Admin") || (userType === "Recruitment Leader") || (userType === "Organization Admin") || (userType === "MIS Operator") || (userType === "Team Leader")) ?
                <>
                    <Backdrop sx={stylesSX.backdrop} open={saving}>
                        <CircularProgress color="inherit" />
                        <Typography >
                            {" "}
                            Please wait ...
                        </Typography>
                    </Backdrop>
                    <div className='mainContainer_requisitionReports'>
                        <div className='topContainer_requisitionReports'>
                            <Header />
                            <div className='mainDiv_requisitionReports'>
                                
                                <div className="main_reports_details_header">
                                    <div className="go_back_reports_details" onClick={() => gotoReports()}>
                                        <Tooltip title="Go Back to Reports" placement="bottom">
                                            <ArrowBackIcon sx={{ fontSize: 20 }} />
                                        </Tooltip>
                                        
                                    </div>
                                    <div className="go_back_reports_details_title">Report-Details</div>

                                </div>

                                <div className='contentcontainer'>
                                    <div className='sideContainer'>
                                        <Box className='search_main_Container'>
                                            <Box className='search_btn_box'>
                                                <div className='text_top'>
                                                    <Typography className=''>Showing Results for</Typography>
                                                    <Typography style={{ color: 'gray', marginTop: "2%" }}>Recruiter Activity Requisition Details</Typography>
                                                </div>
                                                <div className='search_btn_top'>
                                                    <button disabled={loading} className='search_btn' onClick={(event) => handleSearch(event)}>Search</button>
                                                </div>
                                            </Box>

                                            <div className='search_reports_details'>
                                                <div className='search_reports_division_client_block'>
                                                    <Typography variant="subtitle1" gutterBottom>
                                                        Division
                                                    </Typography>
                                                    <Autocomplete
                                                        multiple
                                                        options={clientsDivisions.divisions}
                                                        getOptionLabel={(option) => option.divisionName}
                                                        onChange={handleDivisionChange}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Search Division"
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                <div className='search_reports_division_client_block'>
                                                    <Typography variant="subtitle1" gutterBottom>
                                                        Client Name
                                                    </Typography>
                                                    <Autocomplete
                                                        multiple
                                                        options={clientsDivisions.clients}
                                                        getOptionLabel={(option) => option?.clientName}
                                                        onChange={handleClientNameChange}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Search Client"
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </Box>
                                    </div>
                                    <div className='report_details_container'>
                                        <div className='tabsMainContainer_requisitionReports'>
                                            <div className='tabsContainer_requisitionReports'>
                                                <div className='tabs_requisitionReports_selected'>Report Details</div>
                                            </div>
                                        </div>

                                        <div className='kendoContainer_requisitionReports'>
                                            <div className='export-button'>
                                                <Typography>{loading ? "Searching please wait..." : data[0]?.recruiterDetails?.displayName}</Typography>
                                                <button onClick={exportExcel} className="exportExcelBtn">
                                                    <Excel size={30} className='excelImg_requisitionReports' alt="excelImg" />
                                                    <span>Export</span>
                                                </button>
                                            </div>
                                            <DataTable
                                                data={data || []}
                                                columns={createColumns()}
                                                isLoading={loading}
                                                totalRecords={totalCount || 0}
                                                currentPage={Math.floor(page.skip / page.take) + 1}
                                                pageSize={page.take}
                                                onPageChange={handlePageChange}
                                                onPageSizeChange={handlePageSizeChange}
                                                enableFiltering={false}
                                                enableSorting={true}
                                                enablePagination={true}
                                                isServerSide={true}
                                                pageSizeOptions={[10, 20, 50, 100]}
                                                noDataText="No results found !"
                                                className="kendo_reports"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='bottomContainer_requisitionReports'>
                            <Footer />
                        </div>

                    </div>


                </>
                :
                <>
                    <UnauthorizedAccess />
                </>
            }
        </>
    )
}

export default RequisitionReportDetails